const washingmachine = `Subject: Urgent Repair Request for Washing Machine
Dear Property Manager
I am writing to report a problem with the washing machine in my apartment. 
The machine is leaking water and not completing the wash cycle properly, which is causing a lot of trouble.
I am worried that the water might cause damage to the apartment if it's not fixed quickly. 
It's important to have it repaired as soon as possible to avoid any further issues.
I have also a pile of laundry that needs to be washed.
Please send someone to fix the washing machine as soon as you can. 
I appreciate your prompt attention to this matter.
Thank you.
Sincerely,`;

export default washingmachine;